<form [formGroup]="myTaskForm">
<div class="automation-builder">

  <!-- ================= HEADER ================= -->
  <div class="ab-header">

    <input
      class="ab-name-input"
      type="text"
      formControlName="title"
      maxlength="100"
      placeholder="Automation name..." />

    <div class="ab-header-right">

      <select class="ab-select" [(ngModel)]="automationStatus" [ngModelOptions]="{standalone:true}">
        <option value="Active">Active</option>
        <option value="Paused">Paused</option>
        <option value="Ended">Ended</option>
      </select>

      <select class="ab-select" [(ngModel)]="automationPriority" [ngModelOptions]="{standalone:true}">
        <option value="Low">Low</option>
        <option value="Normal">Normal</option>
        <option value="High">High</option>
        <option value="Urgent">Urgent</option>
      </select>

      <span class="ab-new-badge" *ngIf="isNewAutomation">New</span>

      <button type="button" class="ab-close-btn" (click)="close()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>

    </div>

  </div>


  <!-- ================= BODY ================= -->
  <div class="ab-body">

    <!-- ================= LEFT COLUMN ================= -->
    <div class="ab-col ab-col-left">

      <div class="ab-field-group">
        <label class="ab-label">Description</label>
        <textarea
          class="ab-textarea"
          formControlName="description"
          maxlength="500"
          placeholder="What does this automation do?"
          cdkTextareaAutosize
          cdkAutosizeMinRows="2"
          cdkAutosizeMaxRows="4">
        </textarea>
      </div>


      <div class="ab-field-group">
        <label class="ab-label">Action Type</label>

        <div class="ab-action-grid">
          <button
            type="button"
            class="ab-action-card"
            *ngFor="let action of actionTypes"
            [class.selected]="selectedActionType === action.value"
            (click)="selectActionType(action.value)">
            <mat-icon>{{ action.icon }}</mat-icon>
            <span>{{ action.label }}</span>
          </button>
        </div>
      </div>


      <div class="ab-field-group">
        <label class="ab-label">Attach To</label>

        <div class="ab-pill-row">
          <button type="button" class="ab-pill" [class.selected]="checkedAttachCore" (click)="selectCCC('Core')">
            {{ CoreShowName }}
          </button>
          <button type="button" class="ab-pill" [class.selected]="checkedAttachContact" (click)="selectCCC('Contact')">
            {{ ContactShowName }}
          </button>
          <button type="button" class="ab-pill" [class.selected]="checkedAttachCompany" (click)="selectCCC('Company')">
            {{ CompanyShowName }}
          </button>
        </div>

        <div class="ab-search-wrap" *ngIf="ShowAttchedToCore">
          <input
            class="ab-text-input"
            maxlength="50"
            placeholder="Search {{ CoreShowName }}..."
            [matAutocomplete]="autoCore"
            (input)="searchCore($event.target.value)"
            [formControl]="stateCtrl" />
          <mat-autocomplete #autoCore="matAutocomplete">
            <mat-option (click)="attchedToCoreSelected(core)" *ngFor="let core of attachedToCoreList" [value]="core.name">
              <span class="userlist">
                <div class="userpic">
                  <img *ngIf="core.imageUrl!=''" src="{{core.imageUrl}}" alt="" />
                  <span class="username" *ngIf="core.imageUrl==''">{{ core.shortName }}</span>
                </div>
                <div class="info">
                  <p>{{ core.name }}</p>
                  <p class="email">{{ core.email }}</p>
                </div>
              </span>
            </mat-option>
          </mat-autocomplete>

          <div class="ab-chip-row" *ngIf="attachedToSelectedCore.length > 0">
            <ng-container *ngFor="let core of attachedToSelectedCore">
              <span class="ab-chip" *ngIf="!core.isDeleted">
                {{ core.name }}
                <mat-icon (click)="attchedToRemoveCore(core)">close</mat-icon>
              </span>
            </ng-container>
          </div>
        </div>

        <div class="ab-search-wrap" *ngIf="ShowAttchedToContact">
          <input
            class="ab-text-input"
            maxlength="50"
            placeholder="Search {{ ContactShowName }}..."
            [matAutocomplete]="autoContact"
            (input)="searchContacts($event.target.value)"
            [formControl]="stateCtrl" />
          <mat-autocomplete #autoContact="matAutocomplete">
            <mat-option (click)="attchedToContactSelected(contact)" *ngFor="let contact of attachedToContactList" [value]="contact.name">
              <span class="userlist">
                <div class="userpic">
                  <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="" />
                  <span class="username" *ngIf="contact.imageUrl==''">{{ contact.shortName }}</span>
                </div>
                <div class="info">
                  <p>{{ contact.name }}</p>
                  <p class="email">{{ contact.email }}</p>
                </div>
              </span>
            </mat-option>
          </mat-autocomplete>

          <div class="ab-chip-row" *ngIf="attachedToSelectedContact.length > 0">
            <ng-container *ngFor="let contact of attachedToSelectedContact">
              <span class="ab-chip" *ngIf="!contact.isDeleted">
                {{ contact.name }}
                <mat-icon (click)="attchedToRemoveContact(contact)">close</mat-icon>
              </span>
            </ng-container>
          </div>
        </div>

        <div class="ab-search-wrap" *ngIf="ShowAttchedToCompany">
          <input
            class="ab-text-input"
            maxlength="50"
            placeholder="Search {{ CompanyShowName }}..."
            [matAutocomplete]="autoCompany"
            (input)="searchCompany($event.target.value)"
            [formControl]="stateCtrl" />
          <mat-autocomplete #autoCompany="matAutocomplete">
            <mat-option (click)="attchedToCompanySelected(company)" *ngFor="let company of attachedToCompanyList" [value]="company.name">
              <span class="userlist">
                <div class="userpic">
                  <img *ngIf="company.imageUrl!=''" src="{{company.imageUrl}}" alt="" />
                  <span class="username" *ngIf="company.imageUrl==''">{{ company.shortName }}</span>
                </div>
                <div class="info">
                  <p>{{ company.name }}</p>
                  <p class="email">{{ company.email }}</p>
                </div>
              </span>
            </mat-option>
          </mat-autocomplete>

          <div class="ab-chip-row" *ngIf="attachedToSelectedCompany.length > 0">
            <ng-container *ngFor="let company of attachedToSelectedCompany">
              <span class="ab-chip" *ngIf="!company.isDeleted">
                {{ company.name }}
                <mat-icon (click)="attchedToRemoveCompany(company)">close</mat-icon>
              </span>
            </ng-container>
          </div>
        </div>

        <input
          class="ab-text-input"
          *ngIf="!ShowAttchedToCore && !ShowAttchedToContact && !ShowAttchedToCompany"
          placeholder="Search residents..."
          disabled />

      </div>


      <div class="ab-field-group">
        <label class="ab-label">Assigned To</label>

        <div class="ab-search-wrap">
          <input
            class="ab-text-input"
            maxlength="50"
            placeholder="e.g. Charge Nurse — Floor 2"
            [matAutocomplete]="autoAssignee"
            (input)="searchRoles($event.target.value)"
            [formControl]="roleSearchCtrl" />
          <mat-autocomplete #autoAssignee="matAutocomplete">
            <mat-option (click)="roleSelected(role)" *ngFor="let role of RoleList" [value]="role.roleName">
              <span class="userlist">
                <div class="info">
                  <p>{{ role.roleName }}</p>
                </div>
              </span>
            </mat-option>
          </mat-autocomplete>
        </div>

        <div class="ab-chip-row" *ngIf="selectedAssignedTo.length > 0">
          <span class="ab-chip" *ngFor="let ass of selectedAssignedTo">
            {{ ass.name || ass.email }}
            <mat-icon (click)="removeAssignedTo(ass)">close</mat-icon>
          </span>
        </div>
      </div>

    </div>


    <!-- ================= RIGHT COLUMN ================= -->
    <div class="ab-col ab-col-right">

      <div class="ab-field-group">
        <label class="ab-label">Schedule Repeating Trigger</label>

        <div class="ab-tab-row">
          <button type="button" class="ab-tab" [class.active]="scheduleMode==='Interval'" (click)="setScheduleMode('Interval')">
            Interval
          </button>
          <button type="button" class="ab-tab" [class.active]="scheduleMode==='SpecificDays'" (click)="setScheduleMode('SpecificDays')">
            Specific Days
          </button>
          <button type="button" class="ab-tab" [class.active]="scheduleMode==='DaysOfWeek'" (click)="setScheduleMode('DaysOfWeek')">
            Days of Week
          </button>
        </div>

        <!-- SPECIFIC DAYS -->
        <ng-container *ngIf="scheduleMode==='SpecificDays'">

          <p class="ab-hint">
            Select day(s) from start date — e.g. Day 30 triggers 30 days after the start date.
          </p>

          <div class="ab-day-grid">
            <button
              type="button"
              class="ab-day-chip"
              *ngFor="let day of dayOptions"
              [class.selected]="selectedTriggerDay === day"
              (click)="selectTriggerDay(day)">
              Day {{ day }}
            </button>
          </div>

          <div class="ab-custom-day-row">
            <input
              class="ab-text-input"
              type="number"
              min="1"
              placeholder="Custom day..."
              [(ngModel)]="customDayValue"
              [ngModelOptions]="{standalone:true}" />
            <button type="button" class="ab-add-btn" (click)="addCustomDay()">+ Add</button>
          </div>

        </ng-container>

        <!-- INTERVAL -->
        <div class="ab-interval-row" *ngIf="scheduleMode==='Interval'">
          <span>Every</span>
          <input
            class="ab-text-input ab-interval-input"
            type="number"
            min="1"
            [(ngModel)]="intervalValue"
            [ngModelOptions]="{standalone:true}" />
          <select class="ab-select" [(ngModel)]="intervalUnit" [ngModelOptions]="{standalone:true}">
            <option value="Days">Days</option>
            <option value="Weeks">Weeks</option>
            <option value="Months">Months</option>
          </select>
        </div>

        <!-- DAYS OF WEEK -->
        <div class="ab-dow-row" *ngIf="scheduleMode==='DaysOfWeek'">
          <button
            type="button"
            class="ab-dow-chip"
            *ngFor="let d of daysOfWeekOptions"
            [class.selected]="selectedDaysOfWeek.includes(d)"
            (click)="toggleDayOfWeek(d)">
            {{ d }}
          </button>
        </div>


        <div class="ab-two-col-row">

          <div class="ab-mini-field">
            <label class="ab-label-sm">Start Date</label>
            <input class="ab-text-input" type="date" formControlName="startDate" />
          </div>

          <div class="ab-mini-field">
            <label class="ab-label-sm">Ends</label>
            <select class="ab-select ab-select-block" [(ngModel)]="scheduleEnds" [ngModelOptions]="{standalone:true}">
              <option value="Never">Never</option>
              <option value="After">After occurrences</option>
              <option value="OnDate">On date</option>
            </select>
          </div>

        </div>

      </div>


      <div class="ab-field-group">

        <div class="ab-label-row">
          <label class="ab-label">Email Notifications</label>
          <button type="button" class="ab-add-link" (click)="addEmailNotification()">
            <mat-icon>add</mat-icon>
            Add
          </button>
        </div>

        <p class="ab-hint" *ngIf="emailNotifications.length === 0">
          No notifications set. Click Add to create one.
        </p>

        <div class="ab-email-row" *ngFor="let note of emailNotifications; let i = index">
          <input
            class="ab-text-input"
            type="email"
            placeholder="Recipient email"
            [(ngModel)]="note.email"
            [ngModelOptions]="{standalone:true}" />
          <button type="button" class="ab-remove-btn" (click)="removeEmailNotification(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>

      </div>

    </div>

  </div>


  <!-- ================= FOOTER ================= -->
  <div class="ab-footer">

    <span class="ab-footer-hint" *ngIf="!canCreateAutomation">
      Fill in the automation name and action type to continue.
    </span>
    <span class="ab-footer-spacer" *ngIf="canCreateAutomation"></span>

    <div class="ab-footer-actions">
      <button type="button" class="ab-btn ab-btn-cancel" (click)="close()">
        Cancel
      </button>
      <button
        type="button"
        class="ab-btn ab-btn-primary"
        [disabled]="!canCreateAutomation"
        (click)="SaveTaskDetails(myTaskForm.value)">
        {{ isNewAutomation ? 'Create Automation' : 'Update Automation' }}
        <mat-icon *ngIf="spinner"><mat-spinner diameter="16"></mat-spinner></mat-icon>
      </button>
    </div>

  </div>

</div>
</form>
